(function() {
  const ultraMultiplyer = 1.10;
  const legendaryMultiplyer = 1.20;

  window.playingCards = {
    
    shuffleArray: function(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
    },

    getCardsStats: function(cards, abilities) {
      for (let card of cards) {
        card = playingCards.getCardStats(card, abilities);
      }
      return cards;
    },

    getCardStats: function(card, abilities) {

      if (card.hp == Number(0)) {
        return card;
      }

      card.accuracy = Number(card.accuracy);
      card.attack = Number(card.attack);
      card.defence = Number(card.defence);
      card.hp = Number(card.hp);
      card.originalHp = Number(card.hp);
      card.speed = Number(card.speed);
      card.tier = Number(card.tier);
      card.criticalChance = 4;
      card.move = 1;
      card.turnSkips = 0;

      if (card.cardId) {
        card.image = `/images/cards/${card.cardId}.png`;
      }

      if (abilities && card.ability && abilities[`${card.ability}`]) {
        card.abilityKey = card.ability;
        card.ability = card.ability ? abilities[`${card.ability}`].name : null;
        //card.abilityKey = card.ability ? card.ability.toLocaleLowerCase().replace(/ /g,'') : null;
      }

      if (card.tier == 2) {
        card = playingCards.increaseCardStats(card, ultraMultiplyer);
      } else if (card.tier == 3) {
        card = playingCards.increaseCardStats(card, legendaryMultiplyer);
      }
      return card;
    },

    increaseCardStats: function(card, val) {
      card.attack = Math.round(card.attack * val);
      card.hp = Math.round(card.hp * val);
      //card.accuracy = Math.round(card.accuracy * val);
      card.defence = Math.round(card.defence * val);
      card.speed = Math.round(card.speed * val);
    
      return card;
    },

    groupCardsByTier: function(array) {
      let cards = {
        'ultimate': [],
        'legendary': [],
        'ultra': [],
        'normal': []
      };
      
      // Ultimate cards get added as is, but all other cards get copies added with stat boosts for each tier
      for (let i = 0; i < array.length; i++) {
        let card = array[i];
        if (card.ultimate) {
          card.tier = 4;
          cards['ultimate'].push(card);
        } else {
          card.tier = 1;
          cards['normal'].push(card);
    
          let ultraCopy = Object.assign({}, card);
          ultraCopy.tier = 2;
          cards['ultra'].push(playingCards.increaseCardStats(ultraCopy, ultraMultiplyer));
    
          let legendaryCopy = Object.assign({}, card);
          legendaryCopy.tier = 3;
          cards['legendary'].push(playingCards.increaseCardStats(legendaryCopy, legendaryMultiplyer));
        }
      }
      
      return cards;
    },

    openPack: function(pack, allCards) {
      const allCardsByTier = playingCards.groupCardsByTier(allCards);
      let packSize = pack.size;
      
      cards = [];
      
      if (pack.legendaryGuaranteed) {
        cards.push(playingCards.getCard(allCardsByTier, pack, 'legendary'));
        packSize--;
      }
      
      if (pack.ultraGuaranteed) {
        cards.push(playingCards.getCard(allCardsByTier, pack, 'ultra'));
        packSize--;
      }
      
      for (let i = 0; i < packSize; i++) {
        cards.push(playingCards.getCard(allCardsByTier, pack));
      }
      
      playingCards.shuffleArray(cards);
      
      return cards;
    },


    getCard: function(cards, pack, tier) {
      if (tier) {
        const index = Math.floor(Math.random() * cards[tier].length);
        return cards[tier][index];
      }
      
      const num = Math.random() * 100;
      let index;

      let ultimateChance = Number(pack.ultimateChance);
      let legendaryChance = Number(pack.legendaryChance);
      let ultraChance = Number(pack.ultraChance);
      
      if (num < ultimateChance) {
        index = Math.floor(Math.random() * cards['ultimate'].length);
        return cards['ultimate'][index];
      } else if (num < ultimateChance + legendaryChance) {
        index = Math.floor(Math.random() * cards['legendary'].length);
        return cards['legendary'][index];
      } else if (num < ultimateChance + legendaryChance + ultraChance) {
        index = Math.floor(Math.random() * cards['ultra'].length);
        return cards['ultra'][index];
      } else {
        index = Math.floor(Math.random() * cards['normal'].length);
        return cards['normal'][index];
      }
      
    }
  }
})();